import {createAsyncAction} from 'typesafe-actions';
import { DiscountPlanList, GetAccountDashboardCallsPayload, GetAccountDashboardCallsResponse, GetAccountDashboardCountersPayload, GetAccountDashboardDiscountPlanListPayload, GetAccountProductInfoPayload, PeersContactListItem, ProductInfo, UpdateCallForwardingPayload, UpdateHuntgroupsSubscriptionPayload } from './payloads';
import { GetSipCallsListResponse, SipCall } from '../ringgroups/payloads';
import { APIErrorInterface } from '../../types';
import { RingGroupType } from '../../types/RingGroup';
import { CounterInterface } from '../../types/CustomerAgreementCondition';
import { ServiceFeature } from '../../types/ServiceFeature';

export const getAccountDashboardCalls = createAsyncAction(
    'GET_ACCOUNT_DASHBOARD_CALLS',
    'GET_ACCOUNT_DASHBOARD_CALLS_SUCCESS',
    'GET_ACCOUNT_DASHBOARD_CALLS_FAILED',
)<GetAccountDashboardCallsPayload, {history: GetAccountDashboardCallsResponse, active: GetSipCallsListResponse | null}, undefined>();

export const updateSipCallStatusForAccountDashboardByWebSocketEvent = createAsyncAction(
    'UPDATE_SIP_CALL_STATUS_FOR_ACCOUNT_DASHBOARD_BY_WEBSOCKET',
    'UPDATE_SIP_CALL_STATUS_FOR_ACCOUNT_DASHBOARD_BY_WEBSOCKET_SUCCESS',
    'UPDATE_SIP_CALL_STATUS_FOR_ACCOUNT_DASHBOARD_BY_WEBSOCKET_FAILED',
)<SipCall, SipCall[], APIErrorInterface>();

export const recalcSipCallsDurationForAcoountDashboard = createAsyncAction(
    'RECALC_SIP_CALLS_DURATION_FOR_ACCOUNT_DASHBOARD',
    'RECALC_SIP_CALLS_DURATION_FOR_ACCOUNT_DASHBOARD_SUCCESS',
    'RECALC_SIP_CALLS_DURATION_FOR_ACCOUNT_DASHBOARD_FAILED',
)<undefined, SipCall[], APIErrorInterface>();

export const getAccountDashboardRingGroupList = createAsyncAction(
    'GET_ACCOUNT_DASHBOARD_RING_GROUP_LIST',
    'GET_ACCOUNT_DASHBOARD_RING_GROUP_LIST_SUCCESS',
    'GET_ACCOUNT_DASHBOARD_RING_GROUP_LIST_FAILED',
)<undefined, RingGroupType[], APIErrorInterface>();

export const updateHuntgroupsSubscription = createAsyncAction(
    'UPDATE_HUNTGROUPS_SUBSCRIPTION',
    'UPDATE_HUNTGROUPS_SUBSCRIPTION_SUCCESS',
    'UPDATE_HUNTGROUPS_SUBSCRIPTION_FAILED',
)<UpdateHuntgroupsSubscriptionPayload, undefined, APIErrorInterface>();

export const updateAccountDashboardCallForwardingSettings = createAsyncAction(
    'UPDATE_ACCOUNT_DASHBOARD_CALL_FORWARDING_SETTINGS',
    'UPDATE_ACCOUNT_DASHBOARD_CALL_FORWARDING_SETTINGS_SUCCESS',
    'UPDATE_ACCOUNT_DASHBOARD_CALL_FORWARDING_SETTINGS_FAILED',
)<UpdateCallForwardingPayload, undefined, APIErrorInterface>();

export const getAccountProductInfo = createAsyncAction(
    'GET_ACCOUNT_PRODUCT_INFO',
    'GET_ACCOUNT_PRODUCT_INFO_SUCCESS',
    'GET_ACCOUNT_PRODUCT_INFO_FAILED',
)<GetAccountProductInfoPayload, ProductInfo, APIErrorInterface>();

export const getAccountDashboardCounters = createAsyncAction(
    'GET_ACCOUNT_DASHBOARD_COUNTERS',
    'GET_ACCOUNT_DASHBOARD_COUNTERS_SUCCESS',
    'GET_ACCOUNT_DASHBOARD_COUNTERS_FAILED',
)<GetAccountDashboardCountersPayload, CounterInterface[], APIErrorInterface>();

export const getAccountDashboardDiscountPlanList = createAsyncAction(
    'GET_ACCOUNT_DASHBOARD_DISCOUNT_PLAN_LIST',
    'GET_ACCOUNT_DASHBOARD_DISCOUNT_PLAN_LIST_SUCCESS',
    'GET_ACCOUNT_DASHBOARD_DISCOUNT_PLAN_LIST_FAILED',
)<GetAccountDashboardDiscountPlanListPayload, DiscountPlanList[], APIErrorInterface>();

export const getAccountDashboardPeersContactList = createAsyncAction(
    'GET_ACCOUNT_DASHBOARD_PEER_CONTACTS_LIST',
    'GET_ACCOUNT_DASHBOARD_PEER_CONTACTS_LIST_SUCCESS',
    'GET_ACCOUNT_DASHBOARD_PEER_CONTACTS_LIST_FAILED',
)<undefined, PeersContactListItem[], APIErrorInterface>();